import { Card, Grid } from "@mui/material";
import Wheel, { IWheel } from "../Components/Cards/Wheel";
import WheelsDB from "../Assets/WheelsDB.json";
import { HeaderCard } from "../Components/Cards/MainCard";
import { useEffect } from "react";

const WheelsPage: React.FC = () => {
  const wheels = WheelsDB as object[]; 
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <>
      <HeaderCard />
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 9, md: 12, lg: 10 }}
      >
        {
        wheels.map((item) => {
          const wheel = item as IWheel;
          return (
            <Grid key={wheel.id} item xs={2} sm={3} md={3} lg={2}>
              <Card sx={{ maxWidth: 480 }} elevation={12}>
                <Wheel {...wheel}></Wheel>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default WheelsPage;
